export const GET_ITEMS_CATEGORIES = 'GET_ITEMS_CATEGORIES';
export const GET_ITEMS_CATEGORIES_SUCCESS = 'GET_ITEMS_CATEGORIES_SUCCESS';
export const GET_ITEMS_CATEGORIES_ERROR = 'GET_ITEMS_CATEGORIES_ERROR';
export const RESET_ITEMS_CATEGORIES = 'RESET_ITEMS_CATEGORIES';
